import { theme } from '@citygross/design-tokens';
import styled from 'styled-components';

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${theme.spacings?.xs}px;
`;

type TLinkContainer = {
  backgroundColor?: string;
  hoverBackground?: string;
  isOpen?: boolean;
};

export const LinkContainer = styled.li<TLinkContainer>`
  ${({ backgroundColor, isOpen }) =>
    isOpen && `background-color: ${backgroundColor}`};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    ${({ hoverBackground, isOpen }) =>
      isOpen && `background-color: ${hoverBackground}`};
    text-decoration: underline;
  }
`;

type TMenuItemLabel = {
  fontColor?: string;
};

export const MenuItemLabel = styled.span<TMenuItemLabel>`
  color: ${({ fontColor }) => fontColor};
  display: block;
  font-size: ${theme.typography?.size?.s2}px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type TSideMenuSpacerItem = {
  isSidebar?: boolean;
};

export const SideMenuSpacerItem = styled.li<TSideMenuSpacerItem>`
  ${({ isSidebar }) => isSidebar && `margin-top: ${theme.spacings?.md}px`};
  font-size: ${theme.typography?.size?.s1}px;
  font-weight: ${theme.typography?.weight?.bold};
  padding: ${({ isSidebar }) => (isSidebar ? 4 : 8)}px;
  padding-left: ${theme.spacings?.sm}px;
`;
